/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of `geofence`.
 *
 */
export var GeofenceStatus;
(function (GeofenceStatus) {
    GeofenceStatus["ACTIVE"] = "ACTIVE";
    GeofenceStatus["CLOSED"] = "CLOSED";
    GeofenceStatus["PENDING"] = "PENDING";
})(GeofenceStatus || (GeofenceStatus = {}));
